import type { ReactNode } from 'react'
import { usePermission } from '@/features/permissions/hooks/use-permission'
import type { PermissionKey } from '@/features/permissions/domain/permission'

type Props = {
	permission: PermissionKey
	children: ReactNode
}

const CanView = ({ permission, children }: Props) => {
	const allowed = usePermission(permission)
	if (!allowed) return null
	return <>{children}</>
}

export { CanView }
